import clinicDetails from "./clinicDetails";
import clinics from "./clinics";

export default{
    ...clinicDetails,
    ...clinics,
}